export default __webpack_public_path__ + "static/media/31.6b32e754.jpeg";